import React from 'react';
import './Stats.css';

const Stats = () => {
  const stats = [
    { number: '100+', label: 'Projects', icon: 'fas fa-project-diagram' },
    { number: '50+', label: 'Happy Clients', icon: 'fas fa-smile' },
    { number: '100%', label: 'Positive Reviews', icon: 'fas fa-star' },
    { number: '5+', label: 'Years of Experience', icon: 'fas fa-calendar-alt' }
  ];

  return (
    <section className="stats">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon">
              <i className={stat.icon}></i>
            </div>
            <h3 className="stat-number">{stat.number}</h3>
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;

